/**
 * Simple Sticky ATC - Always Visible
 * No complex logic, just force it to show
 */

(function() {
  'use strict';
  
  // Wait for DOM
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  function init() {
    const stickyAtc = document.querySelector('sticky-atc');
    
    if (!stickyAtc) {
      console.log('Sticky ATC: Element not found');
      return;
    }
    
    // Force show - remove all hiding classes
    stickyAtc.classList.remove('sticky-atc--out');
    stickyAtc.classList.remove('invisible');
    
    // Force visible styles
    stickyAtc.style.display = 'flex';
    stickyAtc.style.visibility = 'visible';
    stickyAtc.style.opacity = '1';
    stickyAtc.style.transform = 'translateY(0)';
    
    console.log('✅ Sticky ATC: Forced visible');
    
    // Update image if product form exists
    updateImage();
    
    // Listen for variant changes
    const productForm = document.querySelector('.js-product-form');
    if (productForm) {
      productForm.addEventListener('change', updateImage);
    }
  }
  
  function updateImage() {
    const stickyAtc = document.querySelector('sticky-atc');
    if (!stickyAtc) return;
    
    const imageContainer = stickyAtc.querySelector('.sticky-atc__image');
    if (!imageContainer) return;
    
    const mainImage = document.querySelector('.media-gallery .main-image .slider__item.is-active img');
    if (mainImage && imageContainer) {
      const imgClone = mainImage.cloneNode(true);
      imgClone.loading = 'lazy';
      imageContainer.innerHTML = '';
      imageContainer.appendChild(imgClone);
    }
  }
  
})();

